import { render, staticRenderFns } from "./GeneralActivityModal.vue?vue&type=template&id=d055243e"
import script from "./GeneralActivityModal.vue?vue&type=script&lang=js"
export * from "./GeneralActivityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports